{
    "validation.required": "{{label}} is a required field",
    "validation.minLength": "{{label}} needs to be at least {{min}} characters long",
    "validation.maxLength": "{{label}} cant be longer than {{max}} characters",
    "validation.contentTypeAlphanumeric": "{{label}} needs to be alphanumeric",
    "validation.contentTypeDate": "{{label}} needs to be a date",
    "validation.contentTypeDateBefore": "{{label}} needs to be a date before {{date beforeDate}}",
    "validation.contentTypeDateAfter": "{{label}} needs to be a date after {{date afterDate}}",
    "validation.contentTypeDatetime": "{{label}} needs to be a date and time",
    "validation.contentTypeDatetimeBefore": "{{label}} needs to be a date before {{datetime beforeDate}}",
    "validation.contentTypeDatetimeAfter": "{{label}} needs to be a date after {{datetime afterDate}}",
    "validation.contentTypeEmail": "{{label}} needs to be a email",
    "validation.contentTypeInteger": "{{label}} needs to be a number",
    "validation.contentTypeNumber": "{{label}} needs to be a number",
    "validation.contentTypeRegex": "{{label}} has the wrong format",
    "validation.contentTypeText": "{{label}} needs to be a text",
    "validation.contentTypeTime": "{{label}} needs to be a time",
    "validation.contentTypeUrl": "{{label}} needs to be a web address",
    "select-element.default-option": "Select…",
    "button-element.network-required": "You are currently offline. Please establish a network connection to continue."
}